import { action, observable } from 'mobx';
import { PumpEditForm, PumpCreateForm } from 'application/pumps/forms';
import {BaseEditViewStore, BaasicDropdownStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {FacilityPumpService} from 'application/pumps/services';
import {ProductService} from 'application/product/services';

@applicationContext
class PumpEditViewStore extends BaseEditViewStore {
    @observable accessor duplicateItems = null;
    constructor(rootStore, componentProps) {
        const id = componentProps && componentProps.modalParams && componentProps.modalParams.data.id;
        const service = new FacilityPumpService(rootStore.application.baasic.apiClient);
        const productService = new ProductService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'pump',
            id: id,
            Form: id ? PumpEditForm : PumpCreateForm,
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        resource.facilityId = rootStore.routerStore.router.routerState.queryParams.facilityId;
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        resource.facilityId = rootStore.routerStore.router.routerState.queryParams.facilityId;                        
                        if(this.duplicateItems == null){
                            this.duplicateItems = 8; // await this.checkExisting();
                            // if(duplicates == 0){
                                // const response = await service.create(resource);
                                // return response.data;
                            // }
                        }
                    }
                }
            },
            FormClass:id ? PumpEditForm : PumpCreateForm,
        });

        this.service = service;

        if(!this.id){
            this.initForm();
            this.onCreate = componentProps.onCreate;
            this.rootStore.viewStore.setNavigationOptions({
                title: null
            });
        }else{
            this.modalParams = componentProps.modalParams;
        }

        this.statusStore = new BaasicDropdownStore({
        }, {
            fetchFunc: async() => {
                const response = await service.getStatus();
                return response;
            }
        });

        this.pumpStore = new BaasicDropdownStore({
            textField: 'itemId'
        }, {
            fetchFunc: async() => {
                const response = await productService.getPumps();
                return response;
            }
        });
    }

    @action.bound
    initForm() {
        this.form.set({stickered: true});
        this.form.set({dateSent: new Date()});
        this.form.set({branch: 'Lakewood'});
    }

    @action.bound
    async getExisting(facilityId, productId, serialNumber) {
        const response = await this.service.getExisting(facilityId, productId, serialNumber);

        return response;
    }

    @action.bound
    async updateResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            await setTimeout(() => this.rootStore.notificationStore.success("PUMPS.EDIT.SUCCESS"));
        }
        catch(error) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                error && error.data ? error.data :  `An error ocurred`
           );  
        }
    }

    @action.bound
    async saveResource(resource) {
        await this.service.create(resource);

        await this.onCreate();

        this.form.reset();
        resource.serialNumber = null;
        this.form.update(resource);
        this.duplicateItems = null;
        this.form.setFieldsDisabled(false);
    }

    @action.bound
    async createResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            resource.facilityId = this.rootStore.routerStore.router.routerState.queryParams.facilityId;                        
            if(this.duplicateItems == null){

                this.duplicateItems = await this.getExisting(resource.facilityId, resource.productId, resource.serialNumber);
                if(this.duplicateItems == 0){
                    await this.saveResource(resource);
                }else{
                    this.form.setFieldsDisabled(false);
                    return;
                }
            }else{
                await this.saveResource(resource);
            }
            await setTimeout(() => this.rootStore.notificationStore.success("PUMPS.ADD.SUCCESS"));
        }
        catch(error) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                error && error.data ? error.data :  `An error ocurred`
           );        
        }
    }
}

export default PumpEditViewStore;
